import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
import { nanoid } from 'nanoid';
import { useCallback, useEffect, useMemo, useRef, useState, } from 'react';
import { InputNumber } from '..';
import { useFirstRender } from '../common/effects/useFirstRender';
import styles from './pin.module.scss';
const Pin = ({ length = 4, RTL = false, onChange, size = 'sm', border = false, autoJump = true, }) => {
    const items = useRef(Array.from({ length }).map(() => ({
        id: nanoid(),
    })));
    const [pinVal, setPinVal] = useState(null);
    const isFirstRender = useFirstRender();
    const wrapperClass = useMemo(() => classNames(styles.wrapper, RTL ? styles.RTL : ''), []);
    const wrapperRef = useRef(null);
    const onRefLoad = useCallback((node) => {
        if (node) {
            wrapperRef.current = node;
        }
    }, []);
    const handleChange = useCallback((val, index) => {
        if (!Number.isNaN(val)) {
            if (index + 1 < length && wrapperRef.current && autoJump) {
                const ele = wrapperRef.current.querySelectorAll('li')[index + 1];
                ele.querySelector('input')?.focus();
            }
            setPinVal(prev => (prev || '') + val);
        }
    }, [pinVal]);
    const handleDelete = useCallback((idx) => {
        const _val = pinVal && pinVal.slice(0, idx);
        if (_val && _val.length < length && idx > 0 && autoJump) {
            wrapperRef.current
                ?.querySelectorAll('li')[idx - 1].querySelector('input')
                ?.focus();
        }
    }, [pinVal]);
    useEffect(() => {
        if (!isFirstRender.current && pinVal) {
            onChange?.(Number.parseInt(pinVal));
        }
    }, [pinVal]);
    const inputWrapperClass = useMemo(() => classNames(styles.input_wrapper, { [styles[size]]: true }), []);
    return (_jsx("ul", { className: wrapperClass, ref: onRefLoad, children: items.current.map(({ id }, index) => (_jsx("li", { className: styles.item, children: _jsx("div", { className: inputWrapperClass, children: _jsx(InputNumber, { size: size, onChange: value => handleChange(value, index), disableControls: true, value: NaN, honorBoundaries: false, border: border, onDelete: () => handleDelete(index), start: 1, end: 9, maxLength: 1 }) }) }, id))) }));
};
Pin.displayName = 'Pin';
export { Pin };
